import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { styled } from '../../themeCustomink';
var SubtleStyles = styled('div', {
    name: 'pigment-colorswatch-subtlety',
})({
    boxSizing: 'border-box',
    position: 'absolute',
    border: "1px dashed ".concat(designTokens.color.gray.slateDark.value),
    borderRadius: '2px',
    top: '2px',
    left: '2px',
    bottom: '2px',
    right: '2px',
});
export var SubtleSwatch = function (_a) {
    var contrastColor = _a.contrastColor;
    return (React.createElement(SubtleStyles, { sx: { border: "1px dashed ".concat(contrastColor) } }));
};
//# sourceMappingURL=SubtleSwatch.js.map